import HttpClientToken from '../../services/HttpClientToken';

import { ObtenerExpedienteVirtualParams, CambiarEstatusExpedienteAutorizadoParams, AudienciaExpedienteProps, ObtenerEtapasExpedienteParams, EtapaProps, ExpedienteVirtualResponse, defaultExpedienteVirtualResponse, EditarExpedienteParams, EditarExhortoRecibidoParams, EditarIrregularParams, EditarAmparoParams, AutorizarExpedienteVirtualParams, AutorizarExpedienteVirtualResponse, defaultAutorizarExpedienteVirtualResponse } from '../../interfaces/tribunal/ExpedienteVirtualInterface';
import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

export const ObtenerExpedienteVirtual = ( params: ObtenerExpedienteVirtualParams ) => {

    return new Promise<ExpedienteVirtualResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/ObtenerExpedienteVirtual', params, token)
            .then( ({ data } : { data : ExpedienteVirtualResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultExpedienteVirtualResponse });
            });

        }

    });

}

export const CambiarEstatusExpedienteAutorizado = ( params: CambiarEstatusExpedienteAutorizadoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/CambiarEstatusExpedienteAutorizado', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const ObtenerAudienciasExpediente = ( idExpediente: number ) => {

    return new Promise<AudienciaExpedienteProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ExpedienteVirtual/AudienciasExpediente/${ idExpediente }`, token)
            .then( ({ data } : { data : AudienciaExpedienteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerEtapasExpediente = ( params: ObtenerEtapasExpedienteParams ) => {

    return new Promise<EtapaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/ObtenerEtapas', params, token)
            .then( ({ data } : { data : EtapaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AutorizarExpedienteVirtual = ( params: AutorizarExpedienteVirtualParams ) => {

    return new Promise<AutorizarExpedienteVirtualResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/AutorizarExpedienteVirtual', params, token)
            .then( ({ data } : { data : AutorizarExpedienteVirtualResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultAutorizarExpedienteVirtualResponse });
            });

        }

    });

}

export const EditarExpediente = ( params: EditarExpedienteParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/EditarExpediente', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const EditarExhortoRecibido = ( params: EditarExhortoRecibidoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/EditarExhortoRecibido', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const EditarIrregular = ( params: EditarIrregularParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/EditarIrregular', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const EditarAmparo = ( params: EditarAmparoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExpedienteVirtual/EditarAmparo', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}
